import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import Icon from '../../../components/AppIcon';

const Toast = ({ message, type = 'info', isVisible, onClose, duration = 3000 }) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  const getToastStyles = () => {
    switch (type) {
      case 'success':
        return 'bg-success text-success-foreground border-success';
      case 'warning':
        return 'bg-warning text-warning-foreground border-warning';
      case 'error':
        return 'bg-error text-error-foreground border-error';
      default:
        return 'bg-primary text-primary-foreground border-primary';
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'CheckCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'error':
        return 'XCircle';
      default:
        return 'Info';
    }
  };

  return createPortal(
    <div className="fixed top-20 right-4 z-50 animate-in slide-in-from-right duration-300">
      <div className={`flex items-center space-x-3 px-4 py-3 rounded-lg border shadow-elevated max-w-sm ${getToastStyles()}`}>
        <Icon name={getIcon()} size={20} />
        <span className="text-sm font-medium flex-1">{message}</span>
        <button
          onClick={onClose}
          className="opacity-70 hover:opacity-100 transition-opacity"
        >
          <Icon name="X" size={16} />
        </button>
      </div>
    </div>,
    document.body
  );
};

export default Toast;